export const MOBILE_HEADER_TOP_OFFSET_PROPERTY = '--ava-mobile-header-top-offset';
export const MOBILE_HEADER_TOP_OFFSET_DEFAULT = 'max(env(safe-area-inset-top), 8px)';
